<template>
  <v-container id="attendance-list">
    <v-form @submit.prevent="onSubmit" ref="form">
      <v-container>
        <h2 class="w-100 text-center title-insert">
          {{ resumoId > 0 ? "Editar" : "Adicionar" }}
          {{
            isSala
              ? "Resumo do Participante"
              : isTur
              ? "Resumo do Município"
              : isGov
              ? "Atores do Projeto"
              : "Atores do Município"
          }}
        </h2>

        <v-row>
          <v-col>
            <v-text-field
              label="Telefone"
              name="telefone"
              type="text"
              v-mask="['(##) ####-####', '(##) #####-####']"
              v-model="resumo.telefone"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <v-text-field
              label="Nome completo"
              name="Nome completo"
              type="text"
              v-model="resumo.nome"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row>
          <v-col cols="3">
            <v-text-field
              label="Ordem"
              name="Ordem"
              type="number"
              v-model="resumo.ordem"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
          <v-col>
            <v-text-field
              label="Email"
              name="email"
              type="text"
              v-model="resumo.email"
              required
              :rules="emailRules"
              background-color="white"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col v-if="!isGov">
            <combobox-instituicao
              :filter="resumo"
              :rules="rules"
            ></combobox-instituicao>
          </v-col>
          <v-col v-else>
            <ComboboxInstituicaoGov
              :filter="resumo"
              :rules="rules"
            ></ComboboxInstituicaoGov>
          </v-col>
          <v-col v-if="resumo.instituicao === 'OUTRA'">
            <v-text-field
              label="Outra Instituição"
              name="outra"
              type="text"
              v-model="resumo.outraInstituicao"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>

        <v-row style="height: 103px">
          <v-col
            cols="1"
            v-if="previewImage"
            style="display: flex; justify-content: center"
          >
            <img
              :src="previewImage"
              style="width: 80%; border-radius: 50%; min-width: 80px"
            />
          </v-col>
          <v-col class="file-names" cols="6">
            <span
              class="name"
              v-if="resumo.fileName && resumo.fileName != 'undefined'"
              >{{ resumo.fileName }}</span
            >
            <v-file-input
              accept="image/jpg, image/jpeg, image/png"
              label="Imagem"
              prepend-icon="mdi-camera"
              v-model="resumo.foto"
              @change="onFileChange"
              :rules="rulesPhoto"
            >
            </v-file-input>
          </v-col>
          <v-col>
            <v-text-field
              label="Cargo/Função"
              name="cargo"
              type="text"
              v-model="resumo.cargo"
              required
              :rules="rules"
              background-color="white"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col class="tipos">
            <div v-if="!isGov">
              <div>Perfil</div>

              <v-radio-group
                v-model="resumo.idMunicipioResumoPerfil"
                row
                :rules="rules"
              >
                <v-radio
                  :label="perfil.nome"
                  :key="perfil.idMunicipioResumoPerfil"
                  :value="perfil.idMunicipioResumoPerfil"
                  v-for="perfil in perfis"
                ></v-radio>
              </v-radio-group>
            </div>
            <div class="check">
              <v-checkbox
                v-model="resumo.recebeAgendas"
                id="atuacao"
                color="primary"
                label="Recebe Agendas"
              />

              <v-checkbox
                v-model="resumo.recebeRelatorio"
                id="atuacao"
                color="primary"
                label="Recebe Relatório"
              />

              <v-checkbox
                v-model="resumo.apareceListagem"
                id="atuacao"
                color="primary"
                label="Aparece na Listagem"
              />
            </div>
          </v-col>
        </v-row>

        <v-row class="row-buttons mt-4">
          <v-btn
            type="button"
            color="error"
            text
            style="margin-left: 10px"
            @click="goToList"
          >
            Cancelar
          </v-btn>
          <v-btn color="primary" type="submit"> Salvar </v-btn>
        </v-row>
      </v-container>
    </v-form>
  </v-container>
</template>
<script>
import { mapActions, mapGetters } from "vuex";
import { AppCityHeader } from "@/modules/city";
import { ComboboxInstituicao } from "@/components/combobox";
import ComboboxInstituicaoGov from "@/modules/instituicao/components/Combobox";

import { resumoMunicipioApi, resumoMunicipioPerfilApi } from "@/apis";

export default {
  components: {
    AppCityHeader,
    ComboboxInstituicao,
    ComboboxInstituicaoGov,
  },
  data() {
    return {
      resumo: {
        apareceListagem: true,
        idMunicipioResumoPerfil: 5,
      },
      perfis: [],
      municipioId: this.$route.params.id,
      isEdit: false,
      resumoId: this.$route.params.resumoId,
      rules: [(v) => !!v || "Campo Obrigatório"],
      emailREgex:
        /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z0-9-]+(?:\.[a-zA-Z0-9-]+)*$/,
      emailRules: [
        (v) =>
          !v
            ? "Campo Obrigatório"
            : !this.emailREgex.test(v)
            ? "E-mail inválido"
            : true,
      ],
      rulesOutras: [
        (v) => {
          if (this.resumo.instituicao === "OUTRA") {
            return "Campo Obrigatório";
          } else {
            return true;
          }
        },
      ],
      rulesPhoto: [
        (v) => {
          if (v) {
            if (v.size > 100000) {
              return "Foto maior que 100kb";
            }
          } else {
            return true;
          }
          return true;
        },
      ],
      previewImage: "",
    };
  },
  computed: {
    ...mapGetters(["isSala", "isTur", "isGov"]),
  },

  mounted() {
    if (this.resumoId > 0) {
      this.setLoading(true);
      resumoMunicipioApi
        .find(this.resumoId)
        .then(({ data }) => {
          this.resumo = data;

          if (!["MUNICIPIO", "SEBRAE"].includes(data.instituicao)) {
            this.resumo.outraInstituicao = this.resumo.instituicao;
            this.resumo.instituicao = "OUTRA";
          }
          if (this.resumo.foto)
            this.previewImage = `data:image/png;base64,${this.resumo.foto}`;

          this.setLoading(false);
        })
        .catch((err) => {
          this.$notification.error("Erro ao encontrar Governança");
          console.log("Erro no mounted ", err);
          this.setLoading(false);
        });
    }
    this.getResumoMunicipioPerfil();
  },
  methods: {
    ...mapActions(["setLoading"]),
    goToList() {
      this.$router.push(`/cidade/${this.municipioId}/resumo-municipio`);
    },
    onFileChange() {
      if (this.resumo.foto) {
        this.previewImage = URL.createObjectURL(this.resumo.foto);
        this.resumo.fileName = this.resumo.foto.name;
      } else {
        this.previewImage = null;
        this.resumo.fileName = null;
      }
    },
    async onSubmit() {
      const valid = await this.check();
      if (!valid) return;

      this.resumo = {
        ...this.resumo,
        instituicao:
          this.resumo.instituicao === "OUTRA"
            ? this.resumo.outraInstituicao
            : this.resumo.instituicao,
        municipioId: this.municipioId,
      };

      let formData = new FormData();

      formData.append("fotoForm", this.resumo.foto || "");
      formData.append("nome", this.resumo.nome);
      formData.append("ordem", this.resumo.ordem);
      formData.append("telefone", this.resumo.telefone);
      formData.append("email", this.resumo.email);
      formData.append(
        "instituicao",
        this.resumo.instituicao || this.resumo.instituicaoId
      );
      formData.append("municipioId", this.resumo.municipioId);
      formData.append(
        "fileName",
        this.resumo.fileName == "undefined" || !this.resumo.fileName
          ? ""
          : this.resumo.fileName
      );
      formData.append("cargo", this.resumo.cargo);
      formData.append(
        "idMunicipioResumoPerfil",
        this.isGov ? 5 : this.resumo.idMunicipioResumoPerfil
      );
      formData.append("recebeAgendas", this.resumo.recebeAgendas || false);
      formData.append("recebeRelatorio", this.resumo.recebeRelatorio || false);
      formData.append("apareceListagem", this.resumo.apareceListagem || false);

      if (this.resumoId > 0) {
        formData.append("resumoId", this.resumo.resumoId);
        resumoMunicipioApi
          .update(formData)
          .then(() => {
            this.$notification.success("Resumo Municipio editado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            this.$notification.error("Erro ao editar Resumo Municipio");
            console.log("Erro no submit ", err);
          });
      } else {
        resumoMunicipioApi
          .create(formData)
          .then((err) => {
            this.$notification.success("Resumo Municipio criado com sucesso!");
            this.goToList();
          })
          .catch((err) => {
            console.log("err.response: ", err.response);

            if (
              err.response &&
              err.response.data &&
              err.response.data.errorTelefone
            ) {
              this.$notification.error(err.response.data.message);
            } else this.$notification.error("Erro ao criar Resumo Municipio");
            console.log("Erro no submit ", err);
          });
      }
    },
    async getResumoMunicipioPerfil() {
      try {
        const { data: resumiMunicipioPerfil } =
          await resumoMunicipioPerfilApi.list();
        this.perfis = resumiMunicipioPerfil;
      } catch (error) {
        this.$notification.error("Erro ao listar perfis do municipio");
      }
    },
    async check() {
      const isValid = await this.$refs.form.validate();
      return isValid;
    },
  },
};
</script>
<style scoped>
.title-insert {
  color: #5c8bb9;
}
.row-buttons {
  display: flex;
  justify-content: flex-end;
}

.file-names {
  position: relative;
  height: 103px;
}

.name {
  position: absolute;
  bottom: 44px;
  left: 46px;
  /* color: #000; */
  width: 62%;
  color: rgba(0, 0, 0, 0.87);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
  font-size: 16px;
  background: #fff;
}

.tipos {
  display: flex;
  column-gap: 8%;
  color: rgba(0, 0, 0, 0.6);
}

.check {
  display: flex;
  column-gap: 10px;
  flex-wrap: wrap;
}
</style>

<style>
#attendance-list .v-file-input__text {
  display: none;
}
</style>
